import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Layout, Menu, Typography, Button } from 'antd';
import {
  DashboardOutlined,
  FileTextOutlined,
  LineChartOutlined,
  PercentageOutlined,
  ArrowLeftOutlined,
} from '@ant-design/icons';
import { getAdminUrl } from '../../services/apiService';
import './OpsLayout.css';

const { Sider, Content, Header } = Layout;

const menuItems = [
  { key: '/ops', icon: <DashboardOutlined />, label: <NavLink to="/ops" end>Dashboard</NavLink> },
  { key: '/ops/faturas', icon: <FileTextOutlined />, label: <NavLink to="/ops/faturas">Faturas</NavLink> },
  { key: '/ops/previsao', icon: <LineChartOutlined />, label: <NavLink to="/ops/previsao">Previsão</NavLink> },
  { key: '/ops/taxas', icon: <PercentageOutlined />, label: <NavLink to="/ops/taxas">Taxas</NavLink> },
];

export default function OpsLayout() {
  const { pathname } = useLocation();
  const selectedKey = menuItems.some((item) => item.key === pathname)
    ? pathname
    : '/ops';

  return (
    <Layout className="ops-layout">
      <Sider width={220} className="ops-sider">
        <div className="ops-brand">
          <Typography.Title level={5}>Saldo Ativo Ops</Typography.Title>
        </div>
        <Menu mode="inline" selectedKeys={[selectedKey]} items={menuItems} />
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          href={getAdminUrl()}
          target="_self"
          className="ops-back-btn"
        >
          Voltar ao Admin
        </Button>
      </Sider>
      <Layout className="ops-main">
        <Header className="ops-header">
          <Typography.Text type="secondary">Gestão financeira — painel interno</Typography.Text>
        </Header>
        <Content className="ops-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
